














import { Component, Vue, Prop, Provide, Emit } from 'vue-property-decorator'

@Component
export default class Ranger extends Vue {
  public status = 'down' // up or down
  @Prop({ type: String, default: '按时间排序' }) public text!: string
  /**
   * clickRanger
   */
  @Emit()
  public clickRanger(status) {
    if (status === 'down') {
      this.status = 'up'
    } else {
      this.status = 'down'
    }
    return this.status
  }
  public mounted() {
    // this.clickRanger(this.status)
  }
}
